import React, { useState, ReactNode, useEffect } from 'react';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import Footer from './Footer/Footer';
import { DevToolsFloatingButton } from './Components/DevTools/DevToolsFloatingButton';

/*
    A component that wraps the page content and provides the sidebar, header, and footer.
    Can be used to wrap any page content.
*/

interface PageLayoutProps {
  children: ReactNode;
}

function PageLayout({ children }: PageLayoutProps) {
  const [sidebarSmall, setSidebarSmall] = useState(false);

  return (
    <div className="tw-h-screen tw-flex tw-flex-col tw-bg-surfaceBlack80">
      {/* Header */}
      <div className="">
        <Header />
      </div>

      {/* Main content */}
      <div className="tw-flex tw-grow tw-pb-[60px] tw-bg-surfaceBlack80">
        {/* Sidebar - collapsed: 64px, expanded: 218px */}
        <aside
          className={`tw-shrink-0 tw-bg-surfaceBlack80 tw-transition-[width] tw-duration-200 tw-ease-out tw-overflow-hidden ${
            sidebarSmall ? 'tw-w-16' : 'tw-w-[218px]'
          }`}
          style={{ borderRight: '1px solid #535D66' }}
        >
          <Sidebar
            isCollapsed={sidebarSmall}
            onToggle={() => setSidebarSmall((prev) => !prev)}
          />
        </aside>

        {/* Main content area - full width so no extra gutter on the right when sidebar expanded */}
        <main className="tw-flex-1 tw-min-w-0 tw-bg-surfaceBlack80 tw-pl-6">
          {' '}
          {/* 1080px is taken from Figma */}
          {children}
        </main>
      </div>

      {/* Footer */}
      <div className="tw-bg-surfaceBlack90">
        <Footer />
      </div>

      <DevToolsFloatingButton />
    </div>
  );
}

export default PageLayout;
